import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Page, Product } from 'npx-family-happy-common';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

export const DEFAULT_PRODUCT_FILTERS: ProductsFilters = {
  serviceID: null,
  searchKey: null,
};

@Injectable({
  providedIn: 'root',
})
export class ProductServiceDashboard {

  private baseURL = `${environment.baseURL}/products`;
  private pricingConfigBaseURL = `${environment.baseURL}/product-pricing-configs`;
  filters = new BehaviorSubject<ProductsFilters>(DEFAULT_PRODUCT_FILTERS)

  constructor(private http: HttpClient) { }
  getAllProducts(
    page: number,
    pageSize = 20,
    filters = DEFAULT_PRODUCT_FILTERS
  ) {
    const params = [
      `pageNumber=${page}`,
      `pageSize=${pageSize}`,
      `${this.convertFilterObjectToQueryParam(filters)}`,
    ].join('&');
    return this.http.get<Page<Product>>(`${this.baseURL}/list?${params}`);
  }
  getProductByID(id: number) {
    return this.http.get<Product>(`${this.baseURL}/${id}`);
  }

  saveProduct(product: Product) {
    return this.http.post<Product>(`${this.baseURL}/`, product);
  }

  deleteProductById(id: number) {
    return this.http.delete<Product>(`${this.baseURL}/${id}`);
  }

  getProductPricingConfigByProductId(productId: number) {
    return this.http.get<ProductPricingConfig>(`${this.pricingConfigBaseURL}/by-product/${productId}`);
  }

  saveProductPricingConfig(config: ProductPricingConfig) {
    return this.http.post<ProductPricingConfig>(`${this.pricingConfigBaseURL}`, config);
  }

  updateProductPricingConfig(config: ProductPricingConfig) {
    return this.http.put<ProductPricingConfig>(`${this.pricingConfigBaseURL}/${config.id}`, config);
  }

  deleteProductPricingConfig(id: number) {
    return this.http.delete(`${this.pricingConfigBaseURL}/${id}`);
  }

  setFilters(filters:any){
    this.filters.next(filters)
  }

  getFilters(){
    return this.filters.asObservable()
  }

  private convertFilterObjectToQueryParam(filters: ProductsFilters) {
    let queryString = '';
    Object.entries(filters).forEach((entry: [string, any | null]) => {
      if (
        entry[1] !== null &&
        ((typeof entry[1] === 'string' && entry[1] !== '') ||
          (typeof entry[1] === 'number' && entry[1] >= 0))
      ) {
        queryString += `${queryString === '' ? '' : '&'}${entry[0]}=${encodeURIComponent(entry[1])}`;
      }
    });
    return queryString;
  }
}

export interface ProductsFilters {
  serviceID: number | null;
  searchKey: string | null;
}

export interface ProductPricingConfig {
  id: number;
  productId: number;
  packageFlatCost: number;
  discountPercentage: number;
  discountedSessions: number;
  poolGroupId?: string | null;
}
